export const ORGON_GROUPS = {
  rim: ['rim-esquerdo', 'rim-direito'],
  pulmao: ['pulmao-esquerdo', 'pulmao-direito']
};

export const YES_OR_NOT = [
  { name: "Sim", value: "1" },
  { name: "Não", value: "2" },
];

export const CORNEA_SLUG = ['cornea-esquerda', 'cornea-direita'];

export const ORGONS_IN_BLOCK = ['pulmao-esquerdo', 'pulmao-direito', 'rim-esquerdo', 'rim-direito'];
